import { render, staticRenderFns } from "./nudges.vue?vue&type=template&id=5c1964c6&scoped=true&"
import script from "./nudges.vue?vue&type=script&lang=js&"
export * from "./nudges.vue?vue&type=script&lang=js&"
import style0 from "./nudges.vue?vue&type=style&index=0&id=5c1964c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1964c6",
  null
  
)

export default component.exports